import axiosTokenInstance from '../../Instances/axiosTokenInstance';
import { toast } from 'react-toastify';
import _ from 'lodash'

export const gncActions = {
    LOADING: 'NEWCASE_LOADING',
    PDFLOADING: 'PDF_LOADING',
    PDFINFOLOADING: 'PDFINFO_LOADING',
    PRECASEIDLOADING: 'PRECASEID_LOADING',
    CHECKINGINVOICENUMBER: 'CHECKING_INVOICE_NUMBER',
    CHECKEDINVOICENUMBER: 'CHECKED_INVOICE_NUMBER',
    ERROR: 'NEWCASE_ERROR',
    DEBITORSFETCHED: 'DEBITORSFETCHED',
    DEBITORSFILTERED: 'DEBITORSFILTERED',
    SELECTDEBITOR: 'SELECTDEBITOR',
    SETFAKTURAHEADER: 'SETFAKTURAHEADER',
    VISUPLOADFAKTURA: 'VISUPLOADFAKTURA',
    EDITFAKTURA: 'EDITFAKTURA',
    EDITFAKTURAWITHAI: 'EDITFAKTURAWITHAI',
    FAKTURADELETED: 'FAKTURADELETED',
    FAKTURADELETEDWITHAI: 'FAKTURADELETEDWITHAI',
    EMPTYFAKTURA: 'EMPTYFAKTURA',
    FAKTURAUPLOADED: 'FAKTURAUPLOADED',
    FAKTURAUPLOADEDWITHAI: 'FAKTURAUPLOADEDWITHAI',
    FAKTURAFINALIZED: 'FAKTURAFINALIZED',
    FAKTURAFINALIZEDWITHAI: 'FAKTURAFINALIZEDWITHAI',
    NEWDEBITOR: 'NEWDEBITOR',
    NEWDEBITORWITHAI: 'NEWDEBITORWITHAI',
    PDFINFOFETCHED: 'PDFINFOFETCHED',
    PDFINFOFAILED: 'PDFINFOFAILED',
    TEMPORARYCASEIDFETCHED: 'TEMPORARYCASEIDFETCHED',
    TEMPORARYCASEFAILED: 'TEMPORARYCASEFAILED',
    NO_DATA: 'NO_DATA',
    RESETCONTAINER: 'RESETCONTAINER',
    SETBASICDATA: 'SETBASICDATA',
    CLEARPDFINFO: 'CLEARPDFINFO',
    CLEARDIFFERENTDEBITOR: 'CLEARDIFFERENTDEBITOR'
}

export const displayForms = {
    DEBITORFILTER: 'DEBITORFILTER',
    EDITDEBITOR: 'EDITDEBITOR',
    EDITDEBITORWITHAI: 'EDITDEBITORWITHAI',
    FAKTURAUPLOAD: 'FAKTURAUPLOAD',
    FAKTURAUPLOADEDIT: 'FAKTURAUPLOADEDIT',
    FAKTURAUPLOADEDITWITHAI: 'FAKTURAUPLOADEDITWITHAI',
    CONFIRM: 'CONFIRM',
    RECEIPT: 'RECEIPT',
    RECEIPTWITHAI: 'RECEIPTWITHAI'
}

const getErrorMessage = (err) => {
    if (_.has(err, 'response.data.title')) {
        return err.response.data.title
    }
    else if (_.has(err, 'response.statusText')) {
        return err.response.statusText
    }
    else if (_.has(err, 'response.data')) {
        return err.response.data
    } else {
        return err.message.toString()
    }
}

const mapDebtorList = (debtorList) => {
    let result = debtorList.map((e, i) => {
        let _filter = Object.values(e).join(";").toUpperCase();
        return {
            ...e,
            isSelected: false,
            newScore: '',
            scoreDate: '',
            filter: _filter,
            debtorName: `${e.firstName} ${e.lastName}`.trim(),
            i: i
        }
    })
    return result
}

const mapFakturaInfo = (fakturaInfo) => {
    return Object.values(fakturaInfo).map((e, i) => {
        let _filter = Object.values(e).join(";").toUpperCase();
        return {
            ...e,
            i: i,
            filter: _filter,
            addressList: e.addressList,
            companyName: e.companyName,
            customerType: e.customerType,
            debtCollectionWarningSent: e.debtCollectionWarningSent,
            debtorCustomerNumber: e.debtorCustomerNumber,
            firstName: e.firstName,
            invoiceLineList: e.invoiceLineList,
            lastName: e.lastName,
            kosAddressList: e.kosAddressList,
            kosinvoiceLineList: e.kosinvoiceLineList,
            invoiceLineType: e.invoiceLineType,
            invoiceLineTypeString: e.invoiceLineTypeString,
            invoiceNumber: e.invoiceNumber,
            invoiceParam: e.invoiceParam,
            specification: e.specification,
        }
    })
}

const newCaseLoading = () => ({
    type: gncActions.LOADING
});

const pdfLoading = () => ({
    type: gncActions.PDFLOADING
});

const pdfInfoLoading = () => ({
    type: gncActions.PDFINFOLOADING
});

const precaseLoading = () => ({
    type: gncActions.PRECASEIDLOADING
});

const checkingInvoiceNumber = () => ({
    type: gncActions.CHECKINGINVOICENUMBER
});

const checkedInvoiceNumber = error => ({
    type: gncActions.CHECKEDINVOICENUMBER,
    data: { error }
});

const newCaseFailure = error => ({
    type: gncActions.ERROR,
    data: { error }
});

const pdfInfoFailure = error => ({
    type: gncActions.TEMPORARYCASEFAILED,
    data: { error }
});

const precaseFailure = error => ({
    type: gncActions.TEMPORARYCASEFAILED,
    data: { error }
});

const pdfInfoFetched = (data, pdfUrl, fileInfo) => ({
    type: gncActions.PDFINFOFETCHED,
    data: { ...data, pdfUrl, fileInfo }
});

export const clearPdfInfo = () => ({
    type: gncActions.CLEARPDFINFO,
});

export const clearDifferentDebitor = () => ({
    type: gncActions.CLEARDIFFERENTDEBITOR,
});

const setBasicData = data => ({
    type: gncActions.SETBASICDATA,
    data: data
})

const debitorsFetched = data => ({
    type: gncActions.DEBITORSFETCHED,
    data: data 
})

const debitorsFiltered = data => ({
    type: gncActions.DEBITORSFILTERED,
    data: data
})

const setNewDebitor = data => ({
    type: gncActions.NEWDEBITOR,
    data: data
})

const setNewDebitorWithAI = data => ({
    type: gncActions.NEWDEBITORWITHAI,
    data: data
})

const setSelectedDebitor = data => ({
    type: gncActions.SELECTDEBITOR,
    data: data
})

// eslint-disable-next-line no-unused-vars
const showVisFaktura = data => ({
    type: gncActions.VISUPLOADFAKTURA,
    data: data
})

// ********** NB SJEKK *** ikke implementert i reducerem
// eslint-disable-next-line no-unused-vars
const hideModal = () => ({
    type: gncActions.HIDEMODAL
});

const visUploadFaktura = data => ({
    type: gncActions.VISUPLOADFAKTURA,
    data: data
})

const setFakturaHeader = data => ({
    type: gncActions.SETFAKTURAHEADER,
    data: data
})

const temporaryIdFetched = (debitorInfo, preCaseId) => ({
    type: gncActions.TEMPORARYCASEIDFETCHED,
    data: { debitorInfo: debitorInfo, preCaseId: preCaseId }
})

const fakturaUploaded = data => ({
    type: gncActions.FAKTURAUPLOADED,
    data: data
})

const fakturaUploadedWithAI = data => ({
    type: gncActions.FAKTURAUPLOADEDWITHAI,
    data: data
})

const fakturaFinalized = data => ({
    type: gncActions.FAKTURAFINALIZED,
    data: data
})

const fakturaFinalizedWithAI = data => ({
    type: gncActions.FAKTURAFINALIZEDWITHAI,
    data: data
})

const setEditFaktura = data => ({
    type: gncActions.EDITFAKTURA,
    data: data
})

// eslint-disable-next-line no-unused-vars
const setEditFakturaWithAI = data => ({
    type: gncActions.EDITFAKTURAWITHAI,
    data: data
})
// eslint-disable-next-line no-unused-vars
const setFakteader = data => ({
    type: gncActions.SETFAKTURAHEADER,
    data: data
})

const setFaktDeleted = data => ({
    type: gncActions.FAKTURADELETED,
    data: data
})

const setFaktDeletedWithAI = data => ({
    type: gncActions.FAKTURADELETEDWITHAI,
    data: data
})

const setEmptyFaktura = data => ({
    type: gncActions.EMPTYFAKTURA,
    data: data
})

const setResetContainer = data => ({
    type: gncActions.RESETCONTAINER,
    data: data
})

export const newCaseGetBasicData = (showToasts, messages) => {

    return dispatch => {
        
        dispatch(newCaseLoading())    
        
        axiosTokenInstance
        ({
            method: 'GET',
            url: `api/sak/GetBasicData`,
        })
        .then((result) => {
            //console.log(result)
            if (result.status !== 200) {
                (showToasts && toast.error(messages['toastGetBasicDataFailed'], {autoClose: false}))
            } else {                
                let data = JSON.parse(result.data)
                //console.log(data)
                if (data.errorCode === "000") {
                    (showToasts && toast.warning(messages['toastGetBasicDataOk']))                    
                    dispatch(setBasicData({ countryList: data.countryList, currencyList: data.currencyList, postalList: data.postalList }))
                } else {
                    (showToasts && toast.warning(messages['toastGetBasicDataFailed'] + ', ' + result.data.errorMessage))
                    dispatch(newCaseFailure(messages['toastGetBasicDataFailed'] + ', ' + result.data.errorMessage))
                }
            }
        })
        .catch((err) => {
            let errormessage = messages['toastGetBasicDataFailed'] + ' ' + getErrorMessage(err)
            toast.error(errormessage, {autoClose: false})            
            dispatch(newCaseFailure(errormessage))
        })
    }
}


export const getDebitorList = (creditorNo, showToasts, messages) => {

    return dispatch => {        
        
        if (creditorNo === '') {
            return
        }
                
        dispatch(newCaseLoading())
        
        axiosTokenInstance
        ({
            method: 'GET',
            url: `/api/sak/GetDebtorList/${creditorNo}`,
        })
        .then((result) => {
            //console.log(result)
            if (result.status !== 200) {
                (showToasts && toast.error(messages['toastGetDebitorsFailed'], {autoClose: false}))                
                dispatch(newCaseFailure(messages['toastGetDebitorsFailed']))
            } else {
                
                let data = JSON.parse(result.data)
                //console.log(data)
                if (data.errorCode === "000") {
                    (showToasts && toast.warning(messages['toastGetDebitorsOk']))
                    
                    // Map om                   
                    let debtorList = mapDebtorList(data.debtorList)                    
                    dispatch(debitorsFetched({ kreditorId: creditorNo, debitorList: debtorList, defaultProduct: data.defaultProduct }))
                } else {
                    (showToasts && toast.warning(messages['toastGetDebitorsFailed'] + ', ' + result.data.errorMessage))
                    //dispatch({ type: actions.HIDE_MODAL, data: null })
                }
            }
        })
        .catch((err) => {
            let errormessage = messages['toastGetDebitorsFailed'] + ' ' + getErrorMessage(err) + ` (/api/sak/GetDebtorList/${creditorNo})`
            toast.error(errormessage, {autoClose: false})
            //dispatch({ type: actions.ERROR, data: errormessage })
            dispatch(newCaseFailure(errormessage))
        })
    }
}


export const filterDebitorList = (filterstring, state, showToasts, messages) => {

    return dispatch => {

        const upperFilter = filterstring.toUpperCase()
        
        let filteredDebitors = []
        
        if (state.debitorList.length > 0) {
            
            dispatch(newCaseLoading())
            
            if (filterstring) {
                filteredDebitors = state.debitorList.filter((x) => {
                    return (x.filter.indexOf(upperFilter) !== -1)
                })
            } else {
                filteredDebitors = state.debitorList
            }
            
            dispatch(debitorsFiltered({
                debitorListFiltered: filteredDebitors,
                filterString: filterstring
            }))
        }
    }
}

export const setDebitor = (debitorModel) => {

    return dispatch => {
        dispatch(newCaseLoading())
        dispatch(setSelectedDebitor({ selectedDebitor: debitorModel }))
    }
}

export const newDebitor = (showToasts, messages) => {

    return dispatch => {
        dispatch(newCaseLoading())        
        dispatch(setNewDebitor({}))        
    }
}

export const newDebitorWithAI = (showToasts, messages) => {

    return dispatch => {
        dispatch(newCaseLoading())        
        dispatch(setNewDebitorWithAI({}))        
    }
}

// Videre til neste form
export const visFakturaListe = (preCaseId) => {

    return dispatch => {

        dispatch(newCaseLoading())
        dispatch(visUploadFaktura(preCaseId))        
    }
}

export const getPDFInfo = (formData, pdfUrl, fileInfo, showToasts, messages) => {

    return dispatch => {

        dispatch(pdfInfoLoading())
        
        axiosTokenInstance
        ({
            method: 'POST',
            url: `/api/sak/GetPDFInfo`,
            data: formData
        })
        .then((result) => {
            // console.log(result)
            if (result.status !== 200) {
                
                (showToasts && toast.error(messages['toastNySakPostPDFInfoFailed'], {autoClose: false}))
                dispatch(pdfInfoFailure(messages['toastNySakPostPDFInfoFailed'] ))
                
            } else {
                // console.log(result.data);
                if (result.data.errorCode === "000") {
                    (showToasts && toast.warning(messages['toastNySakPostPDFInfoOk']))
                    dispatch(pdfInfoFetched(result.data.kCase, pdfUrl, fileInfo))
                } else if (result.data.errorCode === '100') {
                    (showToasts && toast.warning(messages['toastNySakPostPDFInfoNoContent'] + ', ' + + ', ' + result.data.errorMessage))
                    dispatch(pdfInfoFailure(messages['toastNySakPostPDFInfoNoContent'] + + ', ' + result.data.errorMessage))
                } else {
                    (showToasts && toast.warning(messages['toastNySakPostPDFInfoFailed'] + ', ' + + ', ' + result.data.errorMessage))
                    dispatch(pdfInfoFailure(messages['toastNySakPostPDFInfoFailed'] + + ', ' + result.data.errorMessage))
                }
            }
        })
        .catch((err) => {

            let errormessage = messages['toastNySakPostPDFInfoFailed']
            toast.error(errormessage, {autoClose: false})
            dispatch(pdfInfoFailure(errormessage))
            console.log(err)
        })
    }
}

/* 
  Post creditor for å få en Precase id
  Om Ok skal kjøres for å gå videre til neste bilde
*/
export const postNySakDebitor = (formData, showToasts, messages) => {

    return dispatch => {

        if (formData.debtorType === 'Privat') {
            dispatch(setFakturaHeader('Kreditor: ' + formData.CreditorNo + ', debitor: ' + formData.firstName + ' ' + formData.lastName))
        } else {
            dispatch(setFakturaHeader('Kreditor: ' + formData.CreditorNo + ', debitor: ' + formData.debtorName))
        }

        //**** @@@@@ dispatchSetFakturaHeader(formData.CreditorNo + ' ' + formData.debtorName, dispatch, actions, showToasts)
        
        
        dispatch(newCaseLoading())
        
        axiosTokenInstance
        ({
            method: 'POST',
            url: `/api/sak/PostSingleCaseDebitor`,
            data: formData
        })
        .then((result) => {
            //console.log(result)
            
            if (result.status !== 200) {
                
                (showToasts && toast.error(messages['toastNySakPostDebitorFailed'], {autoClose: false}))
                //dispatch({ type: actions.ERROR, data: messages['toastNySakPostDebitorFailed'] })
                dispatch(newCaseFailure(messages['toastNySakPostDebitorFailed'] ))
                
            } else {
                
                if (result.data.errorCode === "000") {
                    //console.log(result.data.preCaseId)
                    const preCaseId = result.data.preCaseId
                    
                    if (_.has(result.data, 'preCaseId')) {
                        (showToasts && toast.warning(messages['toastNySakPostDebitorOk'] + ' (precaseId:' + preCaseId + ').'))
                        dispatch(visFakturaListe(preCaseId))
                    } else {
                        (showToasts && toast.warning(messages['toastNySakPostDebitorFailed'] + ', ' + + ', ' + result.data.errorMessage))
                        //dispatch({ type: actions.ERROR, data: messages['toastNySakPostDebitorFailed'] + + ', ' + result.data.errorMessage })
                        dispatch(newCaseFailure(messages['toastNySakPostDebitorFailed'] + + ', ' + result.data.errorMessage))
                    }
                    
                } else {
                    (showToasts && toast.warning(messages['toastNySakPostDebitorFailed'] + ', ' + + ', ' + result.data.errorMessage))
                    //dispatch({ type: actions.ERROR, data: messages['toastNySakPostDebitorFailed'] + + ', ' + result.data.errorMessage })
                    dispatch(newCaseFailure(messages['toastNySakPostDebitorFailed'] + + ', ' + result.data.errorMessage))
                }
            }
        })
        .catch((err) => {

            let errormessage = messages['toastNySakPostDebitorFailed'] + ' ' + err.response.data
            toast.error(errormessage, {autoClose: false})
            //dispatch({ type: actions.ERROR, data: errormessage })
            dispatch(newCaseFailure(errormessage))
            console.log(err)
        })
    }
}

export const postNySakDebitorWithAI = (formData, showToasts, messages) => {

    return async dispatch => {

        if (formData.debtorType === 'Privat') {
            dispatch(setFakturaHeader('Kreditor: ' + formData.CreditorNo + ', debitor: ' + formData.firstName + ' ' + formData.lastName))
        } else {
            dispatch(setFakturaHeader('Kreditor: ' + formData.CreditorNo + ', debitor: ' + formData.debtorName))
        }        
        
        dispatch(precaseLoading())
        
        try {
            const result_1 = await axiosTokenInstance({
                method: 'POST',
                url: `/api/sak/PostSingleCaseDebitor`,
                data: formData
            });
            if (result_1.status !== 200) {
                (showToasts && toast.error(messages['toastNySakPostDebitorFailed'], { autoClose: false }));
                dispatch(precaseFailure(messages['toastNySakPostDebitorFailed']));
                return null;
            } else {
                if (result_1.data.errorCode === "000") {
                    const preCaseId = result_1.data.preCaseId;

                    if (_.has(result_1.data, 'preCaseId')) {
                        (showToasts && toast.warning(messages['toastNySakPostDebitorOk'] + 'PrecaseId:' + preCaseId + '. Når du er ferdig med å registrere fakturaer må du trykke på "Send inn" for å fullføre saken.', {autoClose: false}));
                        dispatch(temporaryIdFetched(formData, preCaseId))
                        return preCaseId;
                    } else {
                        (showToasts && toast.warning(messages['toastNySakPostDebitorFailed'] + ', ' + +', ' + result_1.data.errorMessage));
                        dispatch(precaseFailure(messages['toastNySakPostDebitorFailed'] + +', ' + result_1.data.errorMessage));
                        return null;
                    }

                } else {
                    (showToasts && toast.warning(messages['toastNySakPostDebitorFailed'] + ', ' + +', ' + result_1.data.errorMessage));
                    //dispatch({ type: actions.ERROR, data: messages['toastNySakPostDebitorFailed'] + + ', ' + result.data.errorMessage })
                    dispatch(precaseFailure(messages['toastNySakPostDebitorFailed'] + +', ' + result_1.data.errorMessage));
                    return null;
                }
            }
        } catch (err) {
            let errormessage = messages['toastNySakPostDebitorFailed'] + ' ' + err.response.data;
            toast.error(errormessage, { autoClose: false });
            //dispatch({ type: actions.ERROR, data: errormessage })
            dispatch(precaseFailure(errormessage));
            console.log(err);
        }
    }
}

export const startUploadFaktura = (formData, fakturaListe, lineNo, clearForm, showToasts, messages ) => {

    return dispatch => { 

        dispatch(newCaseLoading())
        
        axiosTokenInstance
        ({
            method: 'POST',
            url: `/api/sak/PostSingleCaseInvoice`,
            data: formData
        })
        .then((result) => {
            
            if (result.status !== 200) {
                
                (showToasts && toast.error(messages['toastNySakFakturaUploadFailed'], {autoClose: false}))
                //dispatch({ type: actions.ERROR, data: messages['toastNySakFakturaUploadFailed'] })
                dispatch(newCaseFailure(messages['toastNySakFakturaUploadFailed']))
                
            } else {

                if (result.data.errorCode === "000") {
                    (showToasts && toast.warning(messages['toastNySakFakturaUploadOk']))
                    //dispatch({ type: actions.FAKTURAUPLOADED, data: { invoiceList: fakturaListe, lineNo: lineNo } })
                    dispatch(fakturaUploaded({ invoiceList: fakturaListe, lineNo: lineNo }))
                } else {
                    (showToasts && toast.warning(messages['toastNySakFakturaUploadFailed'] + ', ' + + ', ' + result.data.errorMessage))
                    //dispatch({ type: actions.ERROR, data: messages['toastNySakFakturaUploadFailed'] + + ', ' + result.data.errorMessage })
                    dispatch(newCaseFailure(messages['toastNySakFakturaUploadFailed'] + + ', ' + result.data.errorMessage))
                }
            }
        })
        .catch((err) => {
            let errorResponse = err.request.response;

            if (errorResponse.includes("code: 130")) {
                toast.error(errorResponse, {autoClose: false})
                dispatch(checkedInvoiceNumber(errorResponse))
            } else {
                let errormessage = messages['toastNySakPostDebitorFailed'] + ' ' + getErrorMessage(err)
                toast.error(errormessage, {autoClose: false})
                dispatch(newCaseFailure(errormessage))
                console.log(err)
            }
        })
    }
}

export const startUploadFakturaWithAI = (formData, fakturaListe, lineNo, showLoading, clearForm, showToasts, messages ) => {

    return dispatch => { 

        if (showLoading) dispatch(pdfLoading())
        
        return axiosTokenInstance
        ({
            method: 'POST',
            url: `/api/sak/PostSingleCaseInvoice`,
            data: formData
        })
        .then((result) => {
            
            if (result.status !== 200) {                
                (showToasts && toast.error(messages['toastNySakFakturaUploadFailed'], {autoClose: false}))
                dispatch(precaseFailure(messages['toastNySakFakturaUploadFailed']))
                return null;
                
            } else {

                if (result.data.errorCode === "000") {
                    (showToasts && toast.warning(messages['toastNySakFakturaUploadOk'] + '. Husk å sende inn saken når du er ferdig med å registrere fakturaer.', {autoClose: false}))
                    dispatch(fakturaUploadedWithAI({ invoiceList: fakturaListe, lineNo: lineNo }))
                    return "OK";
                    
                } else {
                    (showToasts && toast.warning(messages['toastNySakFakturaUploadFailed'] + ', ' + + ', ' + result.data.errorMessage))
                    dispatch(precaseFailure(messages['toastNySakFakturaUploadFailed'] + + ', ' + result.data.errorMessage))
                    return null;
                }
            }
        })
        .catch((err) => {
            let errorResponse = err.request.response;

            if (errorResponse.includes("code: 130")) {
                toast.error(errorResponse, {autoClose: false})
                dispatch(checkedInvoiceNumber(errorResponse))
            } else {
                let errormessage = messages['toastNySakPostDebitorFailed'] + ' ' + getErrorMessage(err)
                toast.error(errormessage, {autoClose: false})
                dispatch(precaseFailure(errormessage))
                console.log(err)
                return null;
            }
        })
    }
}

export const startFinalizeFaktura = (formData, showToasts, messages) => {

    return dispatch => {
        
        dispatch(newCaseLoading())
        
        axiosTokenInstance
        ({
            method: 'POST',
            url: `/api/sak/PostSingleCaseFinalize`,
            data: formData
        })
        .then((result) => {
            //console.log(result)
            
            if (result.status !== 200) {
                
                (showToasts && toast.error(messages['toastNySakFakturaFinalizeFailed'], {autoClose: false}))
                //dispatch({ type: actions.ERROR, data: messages['toastNySakFakturaFinalizeFailed'] })
                dispatch(newCaseFailure(messages['toastNySakFakturaFinalizeFailed']))
                
            } else {
                
                if (result.data.errorCode === "000") {
                    
                    (showToasts && toast.warning(messages['toastNySakFinalizeOk']))
                    //dispatch({ type: actions.FAKTURAFINALIZED, data: {} })
                    dispatch(fakturaFinalized(result.data.caseNo))
                    
                } else {
                    (showToasts && toast.warning(messages['toastNySakFakturaFinalizeFailed'] + ', ' + + ', ' + result.data.errorMessage))
                    //dispatch({ type: actions.ERROR, data: messages['toastNySakFakturaFinalizeFailed'] + + ', ' + result.data.errorMessage })
                    dispatch(newCaseFailure(messages['toastNySakFakturaFinalizeFailed'] + + ', ' + result.data.errorMessage))
                }
            }
        })
        .catch((err) => {
            
            let errormessage = messages['toastNySakPostDebitorFailed'] + ' ' + getErrorMessage(err)
            toast.error(errormessage, {autoClose: false})
            //dispatch({ type: actions.ERROR, data: errormessage })
            dispatch(newCaseFailure(errormessage))
            console.log(err)
        })
    }
}

export const startFinalizeFakturaWithAI = (formData, showToasts, messages) => {

    return async dispatch => {
        
        dispatch(pdfLoading())
        
        return await axiosTokenInstance
        ({
            method: 'POST',
            url: `/api/sak/PostSingleCaseFinalize`,
            data: formData
        })
        .then((result) => {
            
            if (result.status !== 200) {
                (showToasts && toast.error(messages['toastNySakFakturaFinalizeFailed'], {autoClose: false}))
                dispatch(precaseFailure(messages['toastNySakFakturaFinalizeFailed']))
                return null;
            } else {
                
                if (result.data.errorCode === "000") {
                    (showToasts && toast.warning(messages['toastNySakFinalizeOk']))
                    dispatch(fakturaFinalizedWithAI(result.data.caseNo))
                    return "OK";
                    
                } else {
                    (showToasts && toast.warning(messages['toastNySakFakturaFinalizeFailed'] + ', ' + + ', ' + result.data.errorMessage))
                    dispatch(precaseFailure(messages['toastNySakFakturaFinalizeFailed'] + + ', ' + result.data.errorMessage))
                    return null;
                }
            }
        })
        .catch((err) => {
            
            let errormessage = messages['toastNySakPostDebitorFailed'] + ' ' + getErrorMessage(err)
            toast.error(errormessage, {autoClose: false})
            dispatch(precaseFailure(errormessage))
            console.log(err)
            return null;
        })
    }
}

export const getCheckInvoiceNumber = (invoiceNo, creditorNo, showToasts, messages) => {
    return dispatch => {

        if (creditorNo === '' || invoiceNo === '') {
            return;
        }
        
        dispatch(checkingInvoiceNumber())    
        
        axiosTokenInstance
        ({
            method: 'GET',
            url: `/api/sak/isDuplicateInvoice/${invoiceNo}/${creditorNo}`,
        })
        .then((result) => {   
            if (result.status !== 200) {
                (showToasts && toast.error(`Noe gikk galt ved sjekk på fakturanummer`, {autoClose: false}))
                dispatch(checkedInvoiceNumber())
            } 
            console.log(result)
            if (result.data === true) {
                (showToasts && toast.error(`Fakturanummer ${invoiceNo} eksisterer allerede og kan ikke gjenbrukes.`, {autoClose: false}))
                dispatch(checkedInvoiceNumber(`Fakturanummer ${invoiceNo} eksisterer allerede og kan ikke gjenbrukes.`))
            } else {
                (showToasts && toast.warning(`Fakturanummer ${invoiceNo} er gyldig og kan brukes.`))
                dispatch(checkedInvoiceNumber())
            }
            })
            .catch((err) => {
                (showToasts && toast.error(`Fakturanummer ${invoiceNo} eksisterer allerede og kan ikke gjenbrukes.`, {autoClose: false}))
                dispatch(checkedInvoiceNumber(`Fakturanummer ${invoiceNo} eksisterer allerede og kan ikke gjenbrukes.`))
            });
    }
}

export const startEditFaktura = (lineNo, showToasts) => {

    return dispatch => {
        dispatch(setEditFaktura({ lineNo: lineNo }))        
    }
}

export const startEditFakturaWithAI = (lineNo, showToasts) => {
    return dispatch => {
        dispatch(setEditFakturaWithAI({ lineNo: lineNo }))        
    }
}

export const startDeleteFaktura = (formData, fakturaListe, clearForm, messages, showToasts) => {

    return dispatch => {
        
        dispatch(newCaseLoading())
        
        axiosTokenInstance
        ({
            method: 'POST',
            url: `/api/sak/DeleteSingleCaseInvoice`,
            data: formData
        })
        .then((result) => {
            
            if (result.status !== 200) {
                
                (showToasts && toast.error(messages['toastNySakFakturaDeletedFailed'], {autoClose: false}))
                //dispatch({ type: actions.ERROR, data: messages['toastNySakFakturaDeletedFailed'] })
                dispatch(newCaseFailure(messages['toastNySakFakturaDeletedFailed']))
                
            } else {
                
                if (result.data.errorCode === "000") {                    
                    (showToasts && toast.warning(messages['toastNySakFakturaDeletedOk']))
                    //dispatch({ type: actions.FAKTURADELETED, data: fakturaListe })
                    dispatch(setFaktDeleted(fakturaListe))
                    
                } else {
                    (showToasts && toast.warning(messages['toastNySakFakturaDeletedFailed'] + ', ' + + ', ' + result.data.errorMessage))
                    //dispatch({ type: actions.ERROR, data: messages['toastNySakFakturaDeletedFailed'] + + ', ' + result.data.errorMessage })
                    dispatch(newCaseFailure(messages['toastNySakFakturaDeletedFailed'] + + ', ' + result.data.errorMessage))
                }
            }
        })
        .catch((err) => {
            
            let errormessage = messages['toastNySakFakturaDeletedFailed'] + ' ' + getErrorMessage(err)
            toast.error(errormessage, {autoClose: false})
            //dispatch({ type: actions.ERROR, data: errormessage })
            dispatch(newCaseFailure(errormessage))
            console.log(err)
        })           
    }
}

export const startDeleteFakturaWithAI = (formData, fakturaListe, clearForm, messages, showToasts) => {

    return dispatch => {
        
        dispatch(pdfLoading())
        
        axiosTokenInstance
        ({
            method: 'POST',
            url: `/api/sak/DeleteSingleCaseInvoice`,
            data: formData
        })
        .then((result) => {
            
            if (result.status !== 200) {
                
                (showToasts && toast.error(messages['toastNySakFakturaDeletedFailed'], {autoClose: false}))
                //dispatch({ type: actions.ERROR, data: messages['toastNySakFakturaDeletedFailed'] })
                dispatch(precaseFailure(messages['toastNySakFakturaDeletedFailed']))
                
            } else {
                
                if (result.data.errorCode === "000") {                    
                    (showToasts && toast.warning(messages['toastNySakFakturaDeletedOk']))
                    //dispatch({ type: actions.FAKTURADELETED, data: fakturaListe })
                    dispatch(setFaktDeletedWithAI(fakturaListe))
                    
                } else {
                    (showToasts && toast.warning(messages['toastNySakFakturaDeletedFailed'] + ', ' + + ', ' + result.data.errorMessage))
                    //dispatch({ type: actions.ERROR, data: messages['toastNySakFakturaDeletedFailed'] + + ', ' + result.data.errorMessage })
                    dispatch(precaseFailure(messages['toastNySakFakturaDeletedFailed'] + + ', ' + result.data.errorMessage))
                }
            }
        })
        .catch((err) => {
            
            let errormessage = messages['toastNySakFakturaDeletedFailed'] + ' ' + getErrorMessage(err)
            toast.error(errormessage, {autoClose: false})
            //dispatch({ type: actions.ERROR, data: errormessage })
            dispatch(precaseFailure(errormessage))
            console.log(err)
        })           
    }
}

// Denne gjør tre kall i backend, kredittsjekk på company eller person, oppdater ratingen, og hent debtorlisten på nytt
// Denne blir kun brukt i forbindelse ved Kredittvurdering om bruker trykker på Oppdater tall, har den har for enkelhetsskyld siden vi henter debtorList.
export const getKredittvurderingUpdateList = (formData, creditorNo, showToasts, messages) => {

    return dispatch => {        
        
        if (creditorNo === '') {
            return
        }
                
        dispatch(newCaseLoading())
        
        axiosTokenInstance
        ({
            method: 'POST',
            url: `/api/CreditRating/getCreditRatingUpdateList`,
            data: formData
        })
        .then((result) => {
            //console.log(result)
            if (result.status !== 200) {
                (showToasts && toast.error(messages['toastGetDebitorsFailed'], {autoClose: false}))                
                dispatch(newCaseFailure(messages['toastGetDebitorsFailed']))
            } else {
                
                let data = JSON.parse(result.data)
                //console.log(data)
                if (data.errorCode === "000") {
                    (showToasts && toast.warning(messages['toastGetDebitorsOk']))
                    
                    // Map om                   
                    let debtorList = mapDebtorList(data.debtorList)                    
                    dispatch(debitorsFetched({ kreditorId: creditorNo, debitorList: debtorList, defaultProduct: data.defaultProduct }))
                } else {
                    (showToasts && toast.warning(messages['toastGetDebitorsFailed'] + ', ' + result.data.errorMessage))
                    //dispatch({ type: actions.HIDE_MODAL, data: null })
                }
            }
        })
        .catch((err) => {
            console.log(err)
            let errormessage = messages['toastUpdateDebtorRatingFailed'] + ' ' + getErrorMessage(err) + ` (/api/CreditRating/getCreditRatingUpdateList/${creditorNo})`
            toast.error(errormessage, {autoClose: false})
            //dispatch({ type: actions.ERROR, data: errormessage })
            dispatch(newCaseFailure(errormessage))
        })
    }
}


export const startClearFaktura = () => {
    return dispatch => {
        dispatch(setEmptyFaktura({}))
    }
}

export const resetContainer = () => {

    return dispatch => {
        dispatch(newCaseLoading())
        dispatch(setResetContainer({}))
    }
}
    